<div class="header-class">
    <h6>Lignes du bon de commande : {{ bcLineFormArray?bcLineFormArray.controls.length: ''}}</h6>
</div>
<div class="mat-table">
    <div *ngIf="form">
        <form [formGroup]="form">
            <div class="table_principal">
                <table #table mat-table [dataSource]="matDataSourceBCLigne" formArrayName="bcLines">
                    <caption>Liste des Bcs lignes</caption>
                    <ng-container matColumnDef="libelle">
                        <th mat-header-cell *matHeaderCellDef> Désignation </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.libelle">
                            <div class="with-padding-left">
                                {{element.get('libelle').value}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qte">
                        <th mat-header-cell *matHeaderCellDef> Qte </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                            <div class="with-padding-right">
                                {{ element.get('qte').value| number:'1.4-4' :'fr'}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pu">
                        <th mat-header-cell *matHeaderCellDef> PU </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('pu').value | currency:'EUR':'symbol':'1.2-2':'fr'}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="tva">
                        <th mat-header-cell *matHeaderCellDef> TVA </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            <div> 
                                {{element.get('codeTva').value}} - {{element.get('libelleTva').value }}
                            </div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="naCode">
                        <th mat-header-cell *matHeaderCellDef> NA </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleNa').value" class="centrer">
                            <div> {{element.get('codeNa').value}}</div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cg">
                        <th mat-header-cell *matHeaderCellDef> CG Charge </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleCgCharge').value" class="centrer">
                            <div> {{element.get('codeCgCharge').value}}</div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ca1">
                        <th mat-header-cell *matHeaderCellDef> CA </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleCa1').value" class="centrer">
                            <div>{{element.get('codeCa1').value}}</div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ca2">
                        <th mat-header-cell *matHeaderCellDef> CA2 </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleCa2').value" class="centrer">
                            <div>{{element.get('codeCa2').value}}</div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="complement">
                        <th mat-header-cell *matHeaderCellDef> Complément </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleComp').value" class="centrer">
                            <div>{{element.get('codeComp').value}} </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Equipement">
                        <th mat-header-cell *matHeaderCellDef> Equipement</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            <div>{{element.get('vehicule').value}} </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CodeChantier">
                        <th mat-header-cell *matHeaderCellDef>Code Chantier</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            <div>{{element.get('chantier').value}} </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="mntHt">
                        <th mat-header-cell *matHeaderCellDef> HT</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('ht').value | currency:'EUR':'symbol':'1.2-2':'fr'}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dLivraison">
                        <th mat-header-cell *matHeaderCellDef> Date de livraison</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            {{element.get('dLivraison').value| date: 'dd/MM/yyyy'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ttc">
                        <th mat-header-cell *matHeaderCellDef> TTC </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('ttc').value| currency:'EUR':'symbol':'1.2-2':'fr'}} 
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBC ;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBC; let i = index"></tr>
                </table>
            </div>
        </form>
    </div>
</div>